import { type ObjectValuesUnionType } from '../../utils/typing';

export const BetFilterActionTypes = Object.freeze({
  ASK_BET_FILTER_ROUTE: 'betFilter/askRoute',
  SET_BET_FILTER: 'betFilter/set',
  RECEIVE_BET_FILTER: 'betFilter/receive',
  SET_BET_FILTER_PENDING: 'betFilter/setPending',
});

export type BetFilterActionType = ObjectValuesUnionType<typeof BetFilterActionTypes>;
